import { render, staticRenderFns } from "./FindBack.vue?vue&type=template&id=fb2aac7a&scoped=true&"
import script from "./FindBack.vue?vue&type=script&lang=js&"
export * from "./FindBack.vue?vue&type=script&lang=js&"
import style0 from "./FindBack.vue?vue&type=style&index=0&id=fb2aac7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2aac7a",
  null
  
)

export default component.exports